<mat-selection-list
  disableRipple="true"
  class="listCategories"
  [formControl]="control"
>
  <h3 matSubheader>
    <div>Categories</div>
    <div class="toggle-events-container">
      <mat-checkbox
        (click)="
          $event.stopPropagation(); $event.preventDefault(); toggleAll.emit()
        "
        class="pendo-category-selection-checkbox"
        [checked]="allSelected"
        [indeterminate]="false"
        [matTooltip]="categoriesTooltip()"
      ></mat-checkbox>
    </div>
  </h3>
  <mat-list-option
    *ngFor="let category of categories"
    [class.active]="category.selected"
    [value]="category.value"
    (click)="$event.stopPropagation(); toggleOption.emit(category)"
    class="pendo-category-option"
  >
    <div class="filter-text">
      <span>{{ category.label }}</span>
    </div>
  </mat-list-option>
</mat-selection-list>
